import TripDetailsSubHeading from '../../tripDetailsSubHeading/TripDetailsSubHeading';
import './price.css';

const FixedAndVehiclePrice = ({ data, dateType, group }) => {
    return (
        <div>
            {Array.isArray(data) &&
                data.length > 0 &&
                data.map((priceItem) => {
                    return (
                        <div className='priceDetailsContainer' key={priceItem?.startCity}>
                            <TripDetailsSubHeading text={priceItem?.startCity} />
                            <div className='priceDetailsDiv'>
                                <span className='priceDetailsSpan'>
                                    <strong>Actual Price: </strong>
                                    &#8377;{priceItem?.price?.actual}
                                </span>
                                <span className='priceDetailsSpan'>
                                    <strong>Tax: </strong>
                                    &#8377;{priceItem?.price?.tax}
                                </span>
                                <span className='priceDetailsSpan'>
                                    <strong>Total: </strong>
                                    &#8377;{priceItem?.price?.total}
                                </span>
                                {priceItem?.price?.reserve > 0 && (
                                    <span className='priceDetailsSpan'>
                                        <strong>Reserve: </strong>
                                        &#8377;{priceItem?.price?.reserve}
                                    </span>
                                )}

                                {dateType === 'fixed' && group !== 'vehicle' && (
                                    <>
                                        <span className='priceDetailsSpan'>
                                            <strong>Pickup Location:</strong>
                                        </span>

                                        <ul className=''>
                                            {priceItem?.pickupLocation?.length > 0 &&
                                                priceItem?.pickupLocation?.map((locItem) => {
                                                    return (
                                                        <li key={locItem?._id}>
                                                            <span className='priceDetailsSpan'>{locItem?.name}</span>
                                                        </li>
                                                    );
                                                })}
                                        </ul>
                                    </>
                                )}
                                {dateType === 'fixed' && group === 'vehicle' && (
                                    <>
                                        <span className='priceDetailsSpan'>
                                            <strong>Meetup Location:</strong>
                                        </span>

                                        <ul className=''>
                                            {priceItem?.meetupPoint?.length > 0 &&
                                                priceItem?.meetupPoint?.map((locItem) => {
                                                    return (
                                                        <li key={locItem?._id}>
                                                            <span className='priceDetailsSpan'>{locItem?.name}</span>
                                                        </li>
                                                    );
                                                })}
                                        </ul>
                                    </>
                                )}

                                {group === 'vehicle' && (
                                    <>
                                        {' '}
                                        <span className='priceDetailsSpan'>
                                            <strong>Available Vehicles:</strong>
                                        </span>
                                        <ul className=''>
                                            {priceItem?.vehicle?.map((vehicleItem) => {
                                                return (
                                                    <li key={vehicleItem?._id}>
                                                        <span className='priceDetailsSpan'>{vehicleItem?.name}</span>
                                                        <span>
                                                            <strong>Price: </strong> &#8377;{vehicleItem?.price}
                                                        </span>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </>
                                )}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

export default FixedAndVehiclePrice;
